import React from "react"

const EmptyTbody = ({ message }) => (
  <div className="w-full py-10 px-6 flex flex-row align-center justify-center text-center bg-white">
    <p className="text-sm text-gray-400">{message}</p>
  </div>
)

export default EmptyTbody
